import { useEffect, useState } from "react";
import { useApp } from "../../../context/AppContext";
import { emptyLeadForm } from "../../../components/LeadFields";

/* 设计部客户信息面板与 CRM「新增 / 编辑客户信息」共用同一套 LeadFields；本文件负责 CRM meta 与项目 → 表单预填 */
export const DESIGN_TO_CRM = { los_angeles: "la", norcal: "norcal", san_diego: "sd" };
export const DESIGN_SOURCE = "设计部登记";

export const useCrmMeta = () => {
  const { api } = useApp();
  const [meta, setMeta] = useState(null);
  useEffect(() => { api.get("/crm/meta").then(({ data }) => setMeta(data)).catch(() => setMeta({ error: true })); }, [api]);
  return meta;
};

/* 未关联线索的设计项目 → 按项目已有字段预填（保存时会在 CRM 新建线索并关联） */
export const formFromProject = (p, meta) => {
  const name = (p?.ownerName || "").trim();
  const sp = name.lastIndexOf(" ");
  const br = DESIGN_TO_CRM[p?.branch] || "";
  return { ...emptyLeadForm(meta), firstName: sp > 0 ? name.slice(0, sp) : name, lastName: sp > 0 ? name.slice(sp + 1) : "",
    phone: p?.ownerPhone || "", email: p?.ownerEmail || "", address: p?.address || "", city: p?.city || "", branch: br, region: br,
    serviceType: p?.serviceType || "design_build", projectType: p?.projectType || "detached_adu", stage: "signed", leadSource: DESIGN_SOURCE,
    usDesignOwner: p?.owner || "", cnDraftingOwner: p?.cdDesigner || "", ownerLang: p?.ownerLang || "zh" };
};

/* 新建设计项目（无项目可预填）：分公司按当前列表筛选预选，阶段默认「已签约」，来源默认「设计部登记」 */
export const formForNewProject = (meta, designBranch) => {
  const br = DESIGN_TO_CRM[designBranch] || "";
  return { ...emptyLeadForm(meta), branch: br, region: br, stage: "new", leadSource: DESIGN_SOURCE };
};
